module.exports = "/images/Folder.svg";